import http from '@/http/aisea/axios'
const resource = "/enterprise/container_customer";

export default {
  fetch() {
    return http.get(`${resource}`);
  },

  fetchDetail(itemId) {
    return http.get(`${resource}/${itemId}`);
  },

  update(itemId, payload) {
    return http.put(`${resource}/${itemId}`, payload);
  },

  add(payload) {
    return http.post(`${resource}`, payload);
  },

  delete(itemId) {
    return http.delete(`${resource}/${itemId}`);
  },
  getSummary() {
    return http.get(`${resource}/summary`)
  },
  updateSortOrder(payload) {
    return http.put(`${resource}/sorts`, payload);
  }
};
